import Page from 'components/layout/Page';
import StackOverflowDevStory from './StackOverflowDevStory';
import StackOverflowHero from './StackOverflowHero';
import StackOverflowWarranties from './StackOverflowWarranties';

const StackOverflowComponent: React.FC = () => {
  return (
    <Page hasScrollTop pageVariant="stackOverflow">
      <StackOverflowHero />
      <StackOverflowWarranties />
      <StackOverflowDevStory />
    </Page>
  );
};

export default StackOverflowComponent;
